import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { AXN_ORGANIZATION_ID_PATTERN } from "@constants/url-parameter-patterns";

type DeleteOrganizationRequestResponse = {
    transferObject: AxnCompany;
};

export const deleteOrganizationRequest = async (
    organizationId: string
): Promise<GenericNetworkResponse<DeleteOrganizationRequestResponse>> => {
    const route = injectCustomIdParameter(
        apiRoutes.axnadminCore.axn.referencedata.organization.delete,
        organizationId,
        AXN_ORGANIZATION_ID_PATTERN
    );

    const body = {
        id: organizationId
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};